import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
	selector: 'app-company-confirm-dialog-box',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './company-confirm-dialog-box.component.html',
	styleUrl: './company-confirm-dialog-box.component.scss'
})
export class CompanyConfirmDialogBoxComponent {


	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<CompanyConfirmDialogBoxComponent>,
		private router: Router,
	) { }


	close() {
		this.dialogRef.close();
	}

	goToDashboard() {
		this.close();
		this.router.navigate(['/recruiter-dashboard/dashboard']);

	}

	logout() {
		localStorage.clear();
		this.router.navigate(['/company-auth']);
		this.close();
	}

}
